import { render, staticRenderFns } from "./WisdomDataRuleB.vue?vue&type=template&id=777f8e68&"
import script from "./WisdomDataRuleB.vue?vue&type=script&lang=js&"
export * from "./WisdomDataRuleB.vue?vue&type=script&lang=js&"
import style0 from "./WisdomDataRuleB.vue?vue&type=style&index=0&id=777f8e68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports